import type { ReactNode } from 'react';

import { useAuth } from './auth';

export function usePermission(perm: string): boolean {
  const user = useAuth((s) => s.user);
  if (!user) return false;
  // Mirror backend `require_permission`: platform admins implicitly hold every
  // permission. Without this bypass, the nav filter hides feature links from a
  // freshly-seeded admin whose role memberships are empty.
  if (user.is_platform_admin) return true;
  return user.effective_permissions.includes(perm);
}

interface CanProps {
  perm: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function Can({ perm, children, fallback = null }: CanProps): ReactNode {
  return usePermission(perm) ? children : fallback;
}
